// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SimplePaperPodcast-cls1___9d700277c9bb8fd423a{/*!*/}.SimplePaperPodcast-cls2___ec47e1de00b1c3afb38{padding:6px 16px 8px 16px;border-top:1px solid #f3f4f6}.SimplePaperPodcast-cls2___ec47e1de00b1c3afb38 a{font-size:12px;color:#6b7280;text-decoration:none;font-weight:400}.SimplePaperPodcast-cls2___ec47e1de00b1c3afb38 a:hover{color:#374151;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SimplePaperPodcast-cls1___9d700277c9bb8fd423a",
	"cls2": "SimplePaperPodcast-cls2___ec47e1de00b1c3afb38 SimplePaperPodcast-cls1___9d700277c9bb8fd423a"
};
export default ___CSS_LOADER_EXPORT___;
